<template>
    <div id="app">
        <application-header v-if="$route.path !== '/' || $route.name !=='login'" />
        <notifications group="info" classes="vue-notification" position="top center" :speed="500" />
        <router-view></router-view>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import applicationHeader from './components/shared/header/application-header.vue'

export default {
    name: 'app',
    components: {
        'application-header': applicationHeader
    },
    data () {
        return {
            menuToggle: false
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo'
        })
    },
    methods: {
        ...mapActions({
            getCurrentUserInfo: 'getCurrentUserInfo',
            ping: 'ping',
            getOrganizationList: 'getCurrentOrganizationList'
        }),
        showHideMenu (boolean) {
            if (boolean === 'toggle') {
                this.menuToggle = !this.menuToggle
            } else {
                this.menuToggle = boolean
            }
        }
    },
    created () {
        let self = this
        if (this.$route.name !== 'login') {
            if (self.userInfo.userId === null) {
                this.ping().then((authenticated) => {
                    if (authenticated) {
                        this.getCurrentUserInfo()
                    } else {
                        this.$router.push({name: 'login'})
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss">
    @import './scss/main';
</style>



// WEBPACK FOOTER //
// src/App.vue